import script from "./EditUserProfilePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditUserProfilePage.vue?vue&type=script&lang=ts&setup=true"

import "./EditUserProfilePage.vue?vue&type=style&index=0&id=d83e5796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d83e5796"]])

export default __exports__